import { useMessageNewSocketListener } from '../hooks/useMessageNewSocketListener';
import { usePartnerGroupChatSocketListener } from '../hooks/usePartnerGroupChatSocketListener';
import { usePartnerTemporaryDisableSocketListener } from '../hooks/usePartnerTemporaryDisableSocketListener';

/** Mounts Socket.IO chat handlers (no UI). */
const PartnerSocketListeners = ({ enabled = true }) => {
  usePartnerGroupChatSocketListener({ enabled });
  useMessageNewSocketListener({ enabled });
  usePartnerTemporaryDisableSocketListener({ enabled });
  return null;
};

export default PartnerSocketListeners;
